<template>
    <div class="container">
        <div v-if="shopInfo !== null">
            <modal-x :show="isSelectingTeam" @onclose="isSelectingTeam = false" :content-style="{ maxWidth: '800px' }">
                <h1>Select Team</h1>
                <shops-list :is-select-mode="true" @onselect="onTeamSelected"></shops-list>
            </modal-x>
            <!-- <modal-x :show="isEditingLabel" @onclose="isEditingLabel = false" :content-style="{ maxWidth: '800px' }">
                <label-editor v-if="isEditingLabel" :shop-info="shopInfo"></label-editor>
            </modal-x> -->

            <!-- <modal-x :show="isReplying" @onclose="isReplying = false">
                <paged-reply v-if="isReplying" :to-user-id="shopInfo.shopUserId" page-path="" page-query=""
                    @onpostselect="showPost">
                </paged-reply>
            </modal-x> -->

            <modal-x :show="isSelectingImage" @onclose="isSelectingImage = false">
                <image-list v-if="isSelectingImage" :user-id="shopInfo.shopUserId" @onselect="onImgSelect"></image-list>
            </modal-x>

            <modal-x :show="isSelectingPosts" @onclose="isSelectingPosts = false">
                <post-list v-if="isSelectingPosts" :user-id="shopInfo.shopUserId" @onselect="onPostSelect"></post-list>
            </modal-x>

            <modal-x :show="isEditingPost" @onclose="isEditingPost = false">
                <post-editor v-if="isEditingPost" :user-id="shopInfo.shopUserId"
                    :edit-post-id="editingPostId"></post-editor>
            </modal-x>
            <modal-x :show="isAddingPost" @onclose="isAddingPost = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)', padding: '10px' }">
                <add-post v-if="isAddingPost" @onadded="onPostAdded" :user-id="shopInfo.shopUserId"></add-post>
            </modal-x>

            <!-- <modal-x :show="showCategory" @onclose="showCategory = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
                <div>Listing Categories</div>
                <category v-if="showCategory" :user-id="shopUserId" :cat-node="filterInfo.listingCatNode"
                    cat-type="listing" :showCheckbox="false" :expandAll="true">
                </category>
            </modal-x> -->

            <modal-x :show="showIndustryCats" @onclose="showIndustryCats = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
                <div>Industry Categories</div>
                <category v-if="showIndustryCats" :user-id="shopUserId" :cat-node="industryCatNode" cat-type="industry"
                    @catSelected="onIndustrySelected" :expandAll="true">
                </category>
            </modal-x>

            <!-- <modal-x :show="showShopTagCats" @onclose="showShopTagCats = false"
                :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)', padding: '10px' }">
                <div>Shop Tag Categories</div>
                <category v-if="true" :user-id="shopUserId" :cat-node="shopTagCatNode" cat-type="shopTag" :expandAll="true">
                </category>
            </modal-x> -->

            <div class="row">
                <div style="text-align:center;font-weight:bold;display: flex;flex-direction: column;">
                    <div style="text-align: right">
                        <div v-if="cpdIsManagers">
                            <a :href="apiClient.getAbsUrl('/Account/Shops/?sid=') + shopInfo.shopId" target="_blank">
                                <span>ShopID:{{ shopInfo.shopId }}</span>|
                                <span v-if="dashProfile !== null">{{ dashProfile.accountUser.displayName }}</span>
                            </a> |
                            <a :href="apiClient.getAbsUrl('/Account/Users/?uid=') + shopInfo.shopUserId"
                                target="_blank">
                                <span></span> User Profile
                            </a>
                        </div>
                        <div v-else>
                            <span>ShopID:{{ shopInfo.shopId }}</span>
                        </div>
                    </div>
                    <div v-if="cpdIsShopKeeper || cpdIsManagers" style="display: flex;flex-direction:row;">
                        <div v-if="cpdIsManagers" class="btn btn-default" style="margin:4px;float:left;"
                            @click="$router.push({ path: 'shopsettings', query: { userId: shopUserId } })">Settings
                        </div>

                        <div class="btn btn-default" style="margin:4px;float:left;"
                            @click="$router.push({ path: '/shopList', query: {} })">
                            {{ lang.common.shops }}
                        </div>
                    </div>
                </div>

            </div>


            <div class="row">
                <div class="col-xs-12" style="padding:4px;">
                    <div class="col-xs-12"
                        style="display: flex;flex-direction: row;justify-content: space-evenly;flex-wrap: wrap;">

                        <div @click="isAddingPost = true">
                            <div
                                style="display: flex; justify-content: center; align-items: center; width: 100px; height: 100px; border-radius: 10px; box-shadow: 0px 2px 5px rgba(94, 94, 94, 0.68); cursor: pointer;">
                                <div style="position: relative; width:100px;height:100px;border:1px solid gray;text-align:center;"
                                    class="pbcss-item-add-logo">
                                </div>
                            </div>
                            <div
                                style=" background-color: #fcce00;color: white;font-weight: bolder;padding:2px;margin-top: 2px;text-align: center;">
                                {{ lang.postList.add }}
                            </div>
                        </div>

                        <div @click="$router.push({ path: '/PostList', query: { shopUserId: shopInfo.shopUserId } })">
                            <div
                                style="display: flex; justify-content: center; align-items: center; width: 100px; height: 100px;  border-radius: 10px; box-shadow: 0px 2px 5px rgba(94, 94, 94, 0.68); cursor: pointer;">
                                <div style="position: relative; width:100px;height:100px;border:1px solid gray;text-align:center;"
                                    class="pbcss-items-logo">
                                </div>
                            </div>
                            <div
                                style=" background-color: #fcce00;color: white;font-weight: bolder;padding:2px;margin-top: 2px;text-align: center;">
                                {{ lang.postEditor.posts }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="cpdIsManagers" class="col-xs-12"
                    style="display: flex;flex-direction: row;justify-content: space-evenly;margin: 4px;border:1px solid #fcce00;">
                    <div class="btn btn-default">
                        <a target="_blank" :href="parkingSite">
                            <span class="glyphicon glyphicon-link"> Parking </span>
                        </a>
                    </div>

                    <div class="btn btn-default">
                        <a target="_blank" :href="'/Shopping/Shop/?scode=' + shopInfo.shopCode">
                            <span class="glyphicon glyphicon-link"> SSR </span>
                        </a>
                    </div>

                    <div class="btn btn-default">
                        <router-link :to="{ path: 'Performance', query: { shopUserId: shopInfo.shopUserId } }"><span
                                class="glyphicon glyphicon-stats"></span>
                            Perf</router-link>
                    </div>
                </div>


                <div style="padding:8px 0px;">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs">
                        <li role="presentation" style="cursor:pointer;" @click="changeView('main')"
                            :class="{ active: inView === 'main' }"><a @click.prevent>{{ lang.common.main }}</a>
                        </li>
                        <li role="presentation" style="cursor:pointer;" @click="changeView('configs')"
                            :class="{ active: inView === 'configs' }"><a @click.prevent>{{ lang.common.shopConfigs
                                }}</a>
                        </li>
                        <li role="presentation" style="cursor:pointer;" @click="changeView('qa')"
                            :class="{ active: inView === 'qa' }"><a @click.prevent>{{ lang.common.qaReply }}</a></li>
                        <li role="presentation" style="cursor:pointer;" @click="changeView('categories')"
                            :class="{ active: inView === 'categories' }"><a @click.prevent>{{ lang.common.categories
                                }}</a></li>
                    </ul>
                </div>


                <div class="tab-content" style="padding: 4px;">
                    <div class="tab-pane active">

                        <div class="row" v-if="inView === 'main'">
                            <div class="col-xs-12">
                                <span>{{ lang.common.domainName }}</span>
                                <div style="display: flex;flex-direction: row;">
                                    <input :disabled="disableField" class="form-control" type="text"
                                        v-model="shopInfo.domainName" :placeholder="'...'+landingSite" />
                                    <div class="btn btn-default">
                                        <a target="_blank" :href="landingSite">
                                            <span class="glyphicon glyphicon-link">{{ lang.common.website }}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12">
                                <span>{{ lang.common.shopName }}</span> / <span>{{ lang.common.shopCode }}</span>
                                <div style="display: flex;flex-direction: row;">

                                    <input :disabled="disableField" class="form-control" type="text"
                                        v-model="shopInfo.shopName" />
                                    <div>
                                        <input :disabled="disableField" class="form-control" type="text"
                                            v-model="shopInfo.shopCode" placeholder="shop code" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12">
                                <span>{{ lang.common.shopState }}</span>
                                <select :disabled="disableField" v-model="shopInfo.stateCode" class="form-control">
                                    <option value="0">Active</option>
                                    <option value="1">InActive</option>
                                    <option value="2">Deleted</option>
                                    <option value="1000">Limited</option>
                                </select>
                            </div>

                            <div class="col-xs-12" v-if="cpdIsManagers">
                                <span @click="isSelectingTeam = true" class="btn btn-default">Set Team Id</span>
                                <span @click="shopInfo.teamId = null" class="btn btn-default">Clear TeamId</span>
                                <input :disabled="true" class="form-control" type="text" v-model="shopInfo.teamId" />
                            </div>

                            <div class="col-xs-12" style="padding:4px;">
                                <div :class="{ 'col-md-4': cpdIsManagers }" class="col-xs-12">
                                    <div class="col-xs-12" v-if="cpdIsManagers"
                                        style="padding:4px;border-right: 1px solid gray;">
                                        <div class="col-xs-12">
                                            <div>Enabled functions:</div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                Pickup: <input v-model="shopInfo.pickupEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                OwnPickup: <input v-model="shopInfo.ownPickupEnabled"
                                                    placeholder="theme" type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                TagFilter: <input v-model="shopInfo.tagFilterable" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                        </div>

                                        <div class="col-xs-12">
                                            <div>Enabled Payments:</div>
                                            <!--payments-->
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayPal: <input v-model="shopInfo.payPalEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayCash: <input v-model="shopInfo.payCashEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayFps <input v-model="shopInfo.payFpsEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayMe <input v-model="shopInfo.payMeEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayAtm <input v-model="shopInfo.payAtmEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayAli <input v-model="shopInfo.payAliEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <div style="float:left;margin:4px;border:1px solid gray;padding:4px;">
                                                PayWechat <input v-model="shopInfo.payWechatEnabled" placeholder="theme"
                                                    type="checkbox">
                                            </div>
                                            <!--end payments-->
                                        </div>

                                        <div class="col-xs-12">
                                            <span>Represent ShopId</span>
                                            <input class="form-control" type="text" v-model="shopInfo.repShopId" />
                                        </div>
                                    </div>

                                </div>
                                <div :class="{ 'col-md-8': cpdIsManagers }" class="col-xs-12"
                                    v-if="cpdIsShopKeeper || cpdIsManagers">
                                    <div class="col-xs-12">
                                        <div v-if="cpdIsManagers" class="btn btn-default" style="margin:4px;float:left;"
                                            @click="selectShopIndustry">
                                            <span class="glyphicon glyphicon-triangle-bottom"></span>Industry:
                                            <span v-if="shopInfo.mainCat !== null && shopInfo.mainCat.child !== null">
                                                {{
                                                    shopInfo.mainCat.child.name
                                                }}</span>
                                            <span v-else>Select</span>
                                        </div>
                                        <div v-else>
                                            <span v-if="shopInfo.mainCat !== null">{{ shopInfo.mainCat.parent.name
                                                }}/{{
                                                    shopInfo.mainCat.child.name
                                                }}</span>
                                        </div>
                                    </div>

                                    <div class="col-xs-12" v-if="cpdIsManagers">
                                        <span>View Type</span>
                                        <select :disabled="disableField" v-model="shopInfo.viewCatId"
                                            class="form-control">
                                            <option v-for="opt in viewOptions" :value="opt.value">{{ opt.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12" v-if="cpdIsManagers">

                                <div class="col-md-4 col-xs-12">
                                    <div>Ui Theme</div>
                                    <select v-model="shopInfo.uiTheme" class="form-control">
                                        <option :value="null">default</option>
                                        <option value="home">home</option>
                                        <option value="food">food</option>
                                        <option value="it">it</option>
                                    </select>
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    Body Columns:
                                    <select v-model="shopInfo.uiBody" class="form-control">
                                        <option value="">Please Select</option>
                                        <option value="_oneColumn">Single Column</option>
                                        <option value="_twoColumn">Dual Column</option>
                                    </select>
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    Listing Rows:
                                    <select v-model="shopInfo.uiListing" class="form-control">
                                        <option value="">Please Select</option>
                                        <option value="_oneInRow">One in row</option>
                                        <option value="_oneInRowX2">One in row X2</option>
                                        <option value="_threeInRow">Three in row</option>
                                        <option value="_twoColumns">Two columns</option>
                                        <option value="_twoInRow">Two in row</option>
                                        <option value="_xTwoColumns">X Two columns</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-xs-12" v-if="cpdIsShopKeeper || cpdIsManagers">
                                <span>{{ lang.common.shopIntro }}</span>
                                <textarea class="form-control" rows="10" v-model="shopInfo.intro" />
                            </div>

                            <div class="col-xs-12"
                                style="display: flex;flex-direction: row;justify-content: space-evenly;flex-wrap: wrap;">
                                <div>
                                    <div style="justify-content: center;text-align: center;">
                                        <img :src="shopInfo.logoPath" style="width:100px;height:auto;" />
                                    </div>
                                    <div v-if="cpdIsShopKeeper || cpdIsManagers">
                                        <div class="btn btn-default" @click="selectImg(setNewLogo)">Select Logo
                                        </div> /
                                        <div class="btn btn-default" @click="removeLogo">Remove Logo</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12"
                                style="text-align:center;padding:10px;display: flex;flex-direction: row;justify-content: space-evenly;"
                                v-if="cpdIsShopKeeper || cpdIsManagers">
                                <input type="button" class="btn btn-warning" @click="loadShop" value="Cancel" />
                                <input type="button" class="btn btn-primary" @click="updateShop" value="Update" />
                            </div>
                        </div>


                        <div v-if="inView === 'configs'">
                            <label-editor v-if="inView === 'configs'" :shop-info="shopInfo"></label-editor>
                        </div>

                        <div v-if="inView === 'qa'">
                            <paged-reply v-if="inView === 'qa'" :to-user-id="shopInfo.shopUserId" page-path=""
                                page-query="" @onpostselect="showPost">
                            </paged-reply>
                        </div>

                        <div v-if="inView === 'categories'">
                            <category v-if="inView === 'categories'" :user-id="shopUserId"
                                :cat-node="filterInfo.listingCatNode" cat-type="listing" :showCheckbox="false"
                                :expandAll="true">
                            </category>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    </div>

</template>
<script>
import imageList from './imageList.vue';
import addPost from './addPost.vue';
import postList from './postList.vue';
import postEditor from './postEditor.vue';
import pagedReply from './pagedReply.vue';
import modalX from '../components/base/ModalX1.vue';
import labelEditor from './labelEditor.vue';
import apis from '../api/extApi.js';
import category from './category.vue';
import shopsList from './shopsList.vue';

export default {
    components: {
        shopsList: shopsList,
        category: category,
        labelEditor: labelEditor,
        imageList: imageList,
        postList: postList,
        postEditor: postEditor,
        modalX: modalX,
        pagedReply: pagedReply,
        addPost: addPost
    },
    props: ["shopUserId"],
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        parkingSite: function () {
            if (this.shopInfo === null) return '';
            return '/site/' + this.shopInfo.shopCode;
        },
        landingSite: function () {
            if (this.shopInfo === null) return '';
            let domainName = this.shopInfo.domainName;
            if (domainName && domainName !== "") {
                return '//' + domainName;
            }
            return this.parkingSite;
        },
        cpdIsManagers: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAdmin === true || dp.isManager === true);
        },
        disableField: function () {
            var dp = this.dashProfile;
            var ret = dp !== null && (dp.isAdmin === true || dp.isManager === true);
            return !ret;
        },
        cpdIsAgent: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAgent === true);
        },
        cpdIsShopKeeper: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isShopKeeper === true);
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        },
        cpdShowCategoryButton: function () {
            return this.dashProfile && (!this.dashProfile.hasTeam || this.dashProfile.isAdmin);
        }
    },
    data: function () {
        return {
            shopInfo: null,
            apiClient: apis.api,
            catCodes: apis.api.settings.catCodes,
            uiClient: null,
            //viewOptions corresponse to Enum Nature in NetcoreApi.Models
            viewOptions: [
                { value: 0, name: "None" },
                // { value: 1, name: "Display" },
                // { value: 2, name: "Quotation" },
                { value: 3, name: "SellGoods" },
                // { value: 4, name: "Sell Course" },
                // { value: 5, name: "News" },
                { value: 6, name: "RealProperty" }
            ],
            labels: [],
            cats: [],
            hideList: false,
            hideQas: true,
            bannerCatIds: [],
            isReplying: false,
            isSelectingImage: false,
            isSelectingPosts: false,
            isEditingPost: false,
            isSelectingTeam: false,
            editingPostId: null,
            isAddingPost: false,
            selectedImgs: [],
            imgHandler: null,
            newPostData: { title: null, textMsg: null, userId: null },
            bigCatGrp: null,
            isEditingLabel: false,
            filterInfo: null,
            showCategory: false,
            showIndustryCats: false,
            industryCatNode: null,
            //showShopTagCats: false,
            //shopTagCatNode: null,            
            inView: "main"
        }
    },
    methods: {
        changeView: function (newView) {
            this.inView = newView;
        },
        onTeamSelected: function (shop) {
            this.isSelectingTeam = false;
            console.log('team selected', shop);
            this.shopInfo.teamId = shop.shopUserId;
        },
        onPostAdded: function (ret) {
            this.isAddingPost = false;
            this.onPostSelect(ret);
        },
        editListingCat: function () {
            this.showCategory = true;
        },
        onIndustrySelected(catPair) {
            console.log('industry selected', catPair);
            this.shopInfo.mainCat = catPair;
            this.shopInfo.catId = catPair.child.catId;
            this.showIndustryCats = false;
        },
        selectShopIndustry: function () {
            this.showIndustryCats = true;
            this.loadIndustryCats();
        },
        setNewLogo: function (newImg) {
            this.shopInfo.uiLogo = newImg.fileName + newImg.fileType;
            this.shopInfo.logoPath = newImg.thumbPath;
            this.isSelectingImage = false;
        },
        removeLogo: function () {
            this.shopInfo.uiLogo = "";
            this.shopInfo.logoPath = "";
        },
        selectImg: function (handler) {
            this.imgHandler = handler;
            this.isSelectingImage = !this.isSelectingImage;
        },
        onImgSelect: function (imgFile) {
            this.selectedImgs.push(imgFile);
            this.imgHandler(imgFile, this.selectedImgs);
        },
        showPost: function (postId) {
            this.editingPostId = postId;
            this.isEditingPost = true;
        },
        onPostSelect: function (post) {
            this.showPost(post.postId);
        },
        updateShop: function () {
            this.apiClient.updateShopPrms(this.shopInfo).done((ret) => {
                this.shopInfo = ret.value;
            });
        },
        loadShop: function () {
            this.apiClient.getShopViewModelByUidPrms(this.shopUserId).done((ret) => {
                this.shopInfo = ret.value.shop;
                this.filterInfo = ret.value.filterInfo;
            });
        },
        loadIndustryCats() {
            this.apiClient.getCategoryNodePrms(this.catCodes.industry, this.shopUserId).done((ret) => {
                this.industryCatNode = ret;
            });
        }
    },
    mounted: function () {
        this.loadShop();
        this.uiClient = apis.ui.getShopClient({ userId: this.shopUserId });
    },
    created: function () {

    },
    destroyed: function () {
        this.uiClient.destroy();
    }
}
</script>